<template>
  <div class="owal form field group container">
    <owal-panel-header
      v-if="name"
      position="middle"
      :title="name"
      :buttons="buttons"
      @button-click="handleButton"
      />
    <div :class="`owal form field group content ${wrap ? 'wrap' : 'fit'}`">
      <owal-form-field
        v-for="field in this.fields"
        :key="field.identifier"
        :field="field"
        :initial-value="initialValueForField(field)"
        @change="inputChanged"
        @input="inputChanged"
      />
    </div>

  </div>
</template>

<script>
import OwalFormField from './OwalFormField'
import OwalPanelHeader from '../panels/OwalPanelHeader'
import * as forms from '@/libraries/forms/forms'

export default {
  name: 'OwalFormFieldGroup',
  components: { OwalFormField, OwalPanelHeader },
  props: {
    fieldTemplate: {
      type: Object,
    },
    initialFields: {
      type: Array,
      default: () => [],
    },
    initialSubmission: {
      type: Object,
      required: false,
    },
    inline: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: undefined,
    },
    embedded: {
      type: Boolean,
      default: false,
    },
    layout: {
      type: Object,
      default: function () {
        return {}
      },
    },
  },
  data () {
    return {
      fields: undefined,
    }
  },
  computed: {
    wrap () {
      if (this.layout && this.layout.flexProperties && this.layout.flexProperties.wrap) {
        return this.layout.flexProperties.wrap
      } else return true
    },
    buttons () {
      if (this.fieldTemplate) {
        return [{
          identifier: 'add',
          title: `+ ${this.fieldTemplate.label}`,
        }]
      } else return []
    },
  },
  methods: {
    inputChanged: function (payload) {
      this.$emit('change', payload)
    },
    initialValueForField (field) {
      let initialValue = field.defaultValue
      if (this.initialSubmission) {
        initialValue = this.initialSubmission.valueForField(field.identifier) || initialValue
      }

      return initialValue
    },
    handleButton () {
      const index = this.fields.length + 1
      const template = Object.assign({}, this.fieldTemplate, {
        identifier: `${this.fieldTemplate.identifier}${index}`,
        label: `${this.fieldTemplate.label} ${index}`,
      })

      const formField = new forms.FormField(template)
      this.fields.push(formField)
    },
  },
  mounted () {
    this.fields = this.initialFields
  },
}
</script>

<style scoped>
.owal.panel.middle.header {
  margin-top: 0;
  margin-left: -0.9375rem;
  margin-right: -0.9375rem;
  margin-bottom: 0.9375rem;
}

.owal.form.field.group.content {
  display: flex;
}

.owal.form.field.group.content.wrap {
  flex-wrap: wrap;
}

.owal.form.field.group.content.fit .owal.form.field {
  padding: 0.3975rem;
  margin: 0.3975rem;
}

</style>
